<template>
  <div class="position-relative" :style="{ opacity: loading ? 0.6 : 1, transition: 'opacity 0.3s ease' }">
    <div v-if="loading" class="position-absolute top-50 start-50 translate-middle">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <BTable
      striped
      hover
      :fields="fields"
      :per-page="perPage"
      :items="items"
      :style="{ pointerEvents: loading ? 'none' : 'auto' }"
      empty-text="No records found"
      show-empty
    >
      <template v-slot:head()="head">
        <span
          v-if="sortableColumnsSet.has(head.field.key)"
          @click="$emit('sort', head.field.key)"
          class="cursor-pointer user-select-none d-flex justify-content-between align-items-center"
        >
          <span>{{ head.label }}</span>
          <i :class="getSortIcon(head.field.key)" class="ms-2"></i>
        </span>
        <span v-else>{{ head.label }}</span>
      </template>

      <template v-slot:head(age_cutoff)="head">
        <span @click="$emit('sort', 'age_cutoff')" class="cursor-pointer user-select-none d-flex justify-content-between align-items-center">
          <span>
            {{ head.label }}
            <i
              class="fas fa-info-circle fa-sm text-muted ms-1"
              v-b-tooltip.hover
              title="Records are excluded if the patient is younger than this age. If no age is set, age is not considered."
              style="cursor: help;"
            ></i>
          </span>
          <i :class="getSortIcon('age_cutoff')" class="ms-2"></i>
        </span>
      </template>

      <template v-slot:cell(age_cutoff)="row">
        <span v-if="row.item.age_cutoff === null" class="text-muted">All ages</span>
        <span v-else>{{ row.item.age_cutoff }}</span>
      </template>

      <template v-slot:cell(actions)="row">
        <div class="d-flex gap-2">
          <button
            @click="$emit('edit', row.item)"
            class="btn btn-primary btn-sm"
            title="Edit"
          >
            Edit
          </button>
          <button
            @click="$emit('delete', row.item.id)"
            class="btn btn-danger btn-sm"
            title="Delete"
          >
            Delete
          </button>
        </div>
      </template>
    </BTable>

    <BRow class="my-3">
      <BCol cols="12" class="d-flex justify-content-between align-items-center">
        <div class="small text-muted">
          Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
        </div>
        <BPagination
          :model-value="currentPage"
          @update:model-value="$emit('page-change', $event)"
          :per-page="perPage"
          :total-rows="totalEntries"
          align="center"
        />
        <select :value="perPage" @change="$emit('per-page-change', Number($event.target.value))" class="form-select form-select-sm" style="width: auto;">
          <option :value="10">10 per page</option>
          <option :value="25">25 per page</option>
          <option :value="50">50 per page</option>
          <option :value="100">100 per page</option>
        </select>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import { BTable, BPagination, BRow, BCol, vBTooltip } from 'bootstrap-vue-next';

export default {
  directives: {
    bTooltip: vBTooltip
  },
  components: {
    BTable,
    BPagination,
    BRow,
    BCol
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 10
    },
    totalEntries: {
      type: Number,
      default: 0
    },
    sortField: {
      type: String,
      required: true
    },
    sortOrder: {
      type: String,
      default: 'asc'
    }
  },
  computed: {
    startEntry() {
      return this.totalEntries === 0 ? 0 : (this.currentPage - 1) * this.perPage + 1;
    },
    endEntry() {
      const end = this.currentPage * this.perPage;
      return end > this.totalEntries ? this.totalEntries : end;
    },
    sortableColumns() {
      return ['clinical_formulation_id', 'age_cutoff', 'created_at', 'updated_at'];
    },
    sortableColumnsSet() {
      return new Set(this.sortableColumns);
    }
  },
  methods: {
    getSortIcon(field) {
      if (this.sortField !== field) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    }
  }
};
</script>
